document.addEventListener('DOMContentLoaded', async () => {
    window.__CN_FIX_DONE__ = false;
    const checkoutBtns = document.querySelectorAll("[name='checkout'], .cart__checkout");  
      
    if (checkoutBtns.length > 0) {
      checkoutBtns.forEach(checkoutBtn => {
        checkoutBtn.addEventListener("click", async function (e) {
            if (!window.__CN_FIX_DONE__) {
                e.stopImmediatePropagation(); 
                e.preventDefault();

                console.log("Checkout button clicked, Need to fix the container number!");
                const cart = await getCart();
                await validateAndFixCartItems(cart);
                await new Promise(r => setTimeout(r, 1000));
                window.__CN_FIX_DONE__ = true;
                this.click();
                return;
            }
        }, true);
     });
    }

    if (!window.__RUN_CONTAINER_FIX__){
        console.log("No need to check the container number!");
        return;
    }        

    async function getCart() {
        const response = await fetch('/cart.js');
        return await response.json();
    }

    async function updateLineItemProperty(key, newContainerNumber) {
        await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: key,
            properties: {
            "Container Number": newContainerNumber
            }
        })
        });
    }

    async function validateAndFixCartItems(cart) {
        for (const item of cart.items) {
        const currentContainer = item.properties["Container Number"] || "";
        const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());

        const productTags = product.tags || [];
        // Find the correct CN tag
        const correctTag = productTags.find(tag => tag.startsWith("CN"));
        if (!correctTag) continue;

        const correctContainerNumber = correctTag;

        // Update only if different
        if (currentContainer !== correctContainerNumber) {
            await updateLineItemProperty(item.key, correctContainerNumber);
            console.log(`Updated Container Number for ${item.product_title} => ${correctContainerNumber}`);
        } else {
            console.log(`✅ Correct Container Number for ${item.product_title}`);
        }
        }
    }

    console.log("Need to fix the container number!");
    const cart = await getCart();
    validateAndFixCartItems(cart);
});